export default __webpack_public_path__ + "static/branding-98958cc452868e03478d37cdf1134e25.webp";